"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainMachineAd = mapToDomainMachineAd;
exports.mapToDomainMachineAdsView = mapToDomainMachineAdsView;
const AdMediaType_1 = require("../../enums/AdMediaType");
const AdOwner_1 = require("../../enums/AdOwner");
function mapToAdMediaType(mediaType) {
    return mediaType?.toUpperCase() === AdMediaType_1.AdMediaType.Video
        ? AdMediaType_1.AdMediaType.Video
        : AdMediaType_1.AdMediaType.Image;
}
function mapToAdOwner(owner) {
    return owner?.toUpperCase() === AdOwner_1.AdOwner.Site
        ? AdOwner_1.AdOwner.Site
        : AdOwner_1.AdOwner.SmartPadel;
}
function mapToDomainMachineAd(dto) {
    return {
        id: dto.id,
        title: dto.title,
        mediaType: mapToAdMediaType(dto.mediaType),
        mediaUrl: dto.mediaUrl,
        duration: dto.duration ?? 0,
        owner: mapToAdOwner(dto.owner),
        position: dto.position ?? 0,
        // En el API el flag es `paused`; en la UI trabajamos con `active`.
        active: !(dto.paused ?? false),
    };
}
function mapToDomainMachineSummary(dto) {
    if (!dto?.id)
        return null;
    return {
        id: dto.id,
        code: dto.code,
        name: dto.name,
        siteName: dto.siteName,
    };
}
function mapToDomainMachineAdsView(dto) {
    const ads = (dto.ads ?? [])
        .map(mapToDomainMachineAd)
        .sort((a, b) => a.position - b.position);
    return {
        machine: mapToDomainMachineSummary(dto),
        ads,
    };
}
